import { render, staticRenderFns } from "./DefaultLayoutR.vue?vue&type=template&id=72a3c2aa&scoped=true"
import script from "./DefaultLayoutR.vue?vue&type=script&lang=js"
export * from "./DefaultLayoutR.vue?vue&type=script&lang=js"
import style0 from "./DefaultLayoutR.vue?vue&type=style&index=0&id=72a3c2aa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3c2aa",
  null
  
)

export default component.exports